import { mixins, styled, theme, utils } from 'ui/theme';
import { Card, Link } from 'ui/components/primitives';

export const DRAWER_TRANSITION_TIME = utils.duration.standard;

export const NavBarList = {
  Wrapper: styled('div')`
    background-color: ${theme.colors.build.lightDark1};
    border-top: 1px solid ${theme.colors.build.mediumLight2};
    padding: ${theme.space[4]} ${theme.space[3]} ${theme.space[3]};
    width: 100%;

    &.active {
      border-radius: 0 0px ${theme.space[1]} ${theme.space[1]};
    }

    ${utils.media.min('l')`
      border-radius: ${theme.space[1]};
      border: 0;
      box-shadow: 0px 4px 20px 0px #0000001f;
      padding: ${theme.space[4]};
      left: calc(0px - 292px);
      position: absolute;
      top: 90px;
      width: 560px;
      z-index: 30000;
    `}
  `,

  Dropdown: styled('div')`
    display: flex;
    flex-direction: column;
    gap: ${theme.space[4]};

    ${utils.media.min('l')`
      display: grid;
      grid-template-columns: 1fr;
      width: 100%;
    `}
  `,

  DropdownCard: styled(Card)`
    background: initial;
    grid-template-rows: repeat(3, min-content);
  `,

  Content: styled('div')`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    width: 100%;
  `,

  Component: styled('div')`
    display: flex;
    flex-direction: column;
    gap: ${theme.space[2]};

    &[data-columns='0'] {
      grid-template-columns: 1fr;
    }

    &[data-columns='1'] {
      grid-template-columns: 1fr;
    }

    ${utils.media.min('l')`
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: ${theme.space[4]};
    `}
  `,

  Columns: styled('div')`
    display: flex;
    flex-direction: column;
    gap: ${theme.space[4]};

    ${utils.media.min('l')`
      display: grid;
      column-gap: ${theme.space[4]};
      grid-template-columns: 1fr 1fr;
    `}
  `,

  Card: styled(Card)`
    display: flex;
    ${utils.flexbox.direction.row};
    flex-grow: 1;
    gap: ${theme.space[2]};
  `,

  Svg: styled.span`
    & svg {
      color: ${theme.colors.action.navigation.standard.static};
      width: ${theme.sizes[7]};
    }
  `,

  CardInfo: styled(Link)`
    display: flex;
    ${utils.flexbox.direction.row};
    flex-grow: 1;
    align-items: center;

    &[data-link='false'] {
      text-decoration: none;
      pointer-events: none;
    }
  `,

  Text: styled.div`
    display: block;
    width: 100%;
    text-align: left;

    span {
      color: ${theme.colors.build.darkLight};
      font-size: ${theme.fontSizes.lg};
      margin-bottom: ${theme.space[2]};
      display: flex;
    }

    small {
      font-size: ${theme.fontSizes.md};
      color: ${theme.colors.build.mediumLight1};
      word-break: break-word;
    }
  `,

  Title: styled.span`
    ${mixins.baseFont};
    ${utils.flexbox.direction.row};
    color: ${theme.colors.build.darkDark};
    font-size: ${theme.fontSizes.md};
    gap: ${theme.space[1]};
    margin-bottom: ${theme.space[2]};
    text-align: left;

    ${utils.media.min('l')`
      margin-bottom: ${theme.space[3]};
    `}
  `,

  Logout: styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 0;

    > button {
      align-items: center;
      flex-direction: row;
      gap: ${theme.space[2]};
      height: 50px;
      margin: 0;
      width: 150px;
      max-width: 150px;

      & svg {
        color: ${theme.colors.action.navigation.standard.static};
        width: ${theme.sizes[4]};
      }
    }
  `,
};
